import template from './adpTextLink.html';
import controller from './adpTextLink.controller';
import './adpTextLink.less';

let adpTextLinkComponent = {
  restrict: 'E',
  bindings: {
  	linkText: '@',
  },
  template,
  controller
};

export default adpTextLinkComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpTextLink/adpTextLink.component.js